import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { GlassCard, SectionShell } from './LandingPrimitives';

const bookingFeatures = [
  'Live slot calendar',
  'Waitlist system',
  'Conflict detection',
  'Automated confirmations',
  'Advance payment tracking',
];

const BookingTeaserSection = () => {
  return (
    <SectionShell
      id="booking"
      eyebrow="Booking Management"
      title="Never lose control of your slots"
      description="A fast booking layer that keeps your slots accurate and your staff aligned in real time."
    >
      <div className="grid gap-6 lg:grid-cols-2">
        <GlassCard>
          <ul className="space-y-3">
            {bookingFeatures.map((feature) => (
              <li key={feature} className="flex items-center gap-3 text-sm text-ga-text-muted">
                <CheckCircle2 className="h-4 w-4 text-ga-primary" />
                {feature}
              </li>
            ))}
          </ul>
        </GlassCard>

        <GlassCard className="relative overflow-hidden p-0">
          <div className="absolute right-0 top-0 h-28 w-28 rounded-full bg-ga-lime/20 blur-3xl" />
          <p className="mb-3 px-5 pt-5 text-xs uppercase tracking-[0.16em] text-ga-text-subtle">Booking &amp; Services</p>
          <img
            src={`${process.env.PUBLIC_URL}/images/preview-booking.png`}
            alt="GroundAale booking management with services like Practice Net, Group Net, Box Arena and Cricket Ground"
            className="w-full rounded-b-xl"
            loading="lazy"
          />
        </GlassCard>
      </div>
    </SectionShell>
  );
};

export default BookingTeaserSection;
